export default "__VITE_ASSET__Di4C35D2__"